import type { MyTasksParams, MyOverdueTasksParams, MyTimeAnalysisParams } from '../types';

/** Personal Summary is user-scoped, never org-scoped — no `orgId` in any key. */
export const PERSONAL_SUMMARY_KEYS = {
  all: ['me', 'summary'] as const,
  tasks: (params?: MyTasksParams) => ['me', 'summary', 'tasks', params] as const,
  overdueTasks: (params?: MyOverdueTasksParams) =>
    ['me', 'summary', 'overdue-tasks', params] as const,
  timeAnalysis: (params?: MyTimeAnalysisParams) =>
    ['me', 'summary', 'time-analysis', params] as const,
};
